import PropTypes from 'prop-types';
import React from 'react';

/**
 * Channel multi-select — toggle chips (coloured dot + label) to focus the view
 * on a subset of channels. Pairs with the universal "Channel breakdown" toggle:
 * deselect a channel and it drops out of the KPI totals, the per-channel
 * breakdown, the legend, and the stacked charts.
 *
 * channels: [{ id, label, color }]
 * selectedIds: number[]   onChange: (nextIds) => void
 */
const ChannelFilter = ({ channels, selectedIds, onChange, className = '' }) => {
  if (!channels || !channels.length) return null;

  const toggle = id => {
    const isOn = selectedIds.includes(id);
    // keep at least one selected
    if (isOn && selectedIds.length === 1) return;
    onChange(isOn ? selectedIds.filter(x => x !== id) : [...selectedIds, id]);
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {channels.map(ch => {
        const active = selectedIds.includes(ch.id);
        return (
          <button
            key={ch.id}
            type="button"
            onClick={() => toggle(ch.id)}
            aria-pressed={active}
            className={`flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
              active
                ? 'border-grey-dark bg-white text-black'
                : 'border-grey bg-grey-light text-grey-darker'
            }`}
          >
            <span
              className="inline-block rounded-full"
              style={{
                width: 10,
                height: 10,
                backgroundColor: active ? ch.color : 'transparent',
                border: active ? 'none' : `2px solid ${ch.color}`,
                opacity: active ? 1 : 0.5,
              }}
            />
            {ch.label}
          </button>
        );
      })}
    </div>
  );
};

ChannelFilter.propTypes = {
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
  selectedIds: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default ChannelFilter;
